import React, { useState } from 'react';
import { Modal, Radio, RadioGroup } from '@workboard/wobo-ui';
import axios from 'axios';
import { Alert } from '@material-ui/lab';
import { useTranslation } from 'react-i18next';

interface IProps {
  teamId: number;
  isTeamVisible: boolean;
  onClose: () => void;
}

const TeamSettingsModal = ({
  teamId,
  isTeamVisible,
  onClose,
}: IProps): JSX.Element => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(isTeamVisible);
  const [showAlert, setShowAlert] = useState(false);

  const handleSubmit = async (): Promise<void> => {
    try {
      const config = {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      };

      await axios.patch(
        '/wb/teams/changeTeamVisibility',
        { teamId, isVisible },
        config,
      );
      window.location.reload();
    } catch (error) {
      setShowAlert(true);
    }
  };

  return (
    <>
      <Modal
        open
        onDismiss={onClose}
        onSubmit={handleSubmit}
        title={t('Team visibility for non-members')}
      >
        {showAlert && (
          <Alert severity="warning">
            {t('Unable to change team visibility!')}
          </Alert>
        )}

        <RadioGroup
          label={t(
            'Allow this team to be discoverable in search results and Team lists?',
          )}
          value={isVisible ? 'Yes' : 'No'}
          onChange={() => setIsVisible(!isVisible)}
        >
          <Radio label={t('Yes')} value="Yes" />
          <Radio label={t('No')} value="No" />
        </RadioGroup>
      </Modal>
    </>
  );
};

export default TeamSettingsModal;
